import { InfoDialog } from '@strata/react-dialog';
import { DisplayRichText } from '@strata/react-rich-text-area';
import { ComponentProps } from 'react';

import { ReferralDetails } from 'store/api/treatmentApi';

interface NoticeDetailsDialogProps {
    noticeDetails?: ReferralDetails['copayAssistanceMessage'];
    onSecondaryButtonClick: ComponentProps<typeof InfoDialog>['onClose'];
}

export const NoticeDetailsDialog = ({
    noticeDetails = undefined,
    onSecondaryButtonClick,
}: NoticeDetailsDialogProps) => (
    <InfoDialog
        dialogTitle={noticeDetails?.title ?? ''}
        isOpen={!!noticeDetails}
        onClose={onSecondaryButtonClick}
        dialogContent={
            noticeDetails?.longMessage ? (
                <DisplayRichText value={noticeDetails?.longMessage} />
            ) : null
        }
    />
);
